import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BzAlertActions } from './core/reducers/alert.actions';
import { BzAlertMessage } from './core/models/alertMessage';

@Injectable()
export class BzAlertService implements IBzAlertService {

  public constructor(
    private _store: Store<IBzAlertState>,
    private _bzAlertActions: BzAlertActions
  ) { }

  public dispatchMessage(alert: IBzAlertMessage): void {
    const object: any = Object;
    let alertMessage: IBzAlertMessage = new BzAlertMessage();
    alertMessage = object.assign(alertMessage, alert);
    this._store.dispatch(this._bzAlertActions.Add([alertMessage]));
  }

  public observerCurrentMessage(): Observable<any> {
    return this._store.select((s) => s.alertMessages);
  }

}
